import { Service } from '@genial/services';
import {
  FixedIncomeResponsesExternalsApprovalWithdrawRequest,
  FixedIncomeResponsesExternalsPerformWithdrawRequest,
  FundWithdrawExecuteRequest,
  TreasuryWithdrawRequest,
} from '@genial/services/dist/models';
import { useRecoilValue } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../master/selector';

import { screenName } from './constants';

export const useRedemptionActions = () => {
  const selectedAdvisor = useRecoilValue(advisorIdToApisSelector);
  const selectedPartner = useRecoilValue(partnerIdToApisSelector);

  const executeFundsRedemption = (fundWithdrawOptions: FundWithdrawExecuteRequest) => {
    return Service.Fund.V1.postWithdrawExecute({
      screenName,
      fundWithdrawExecuteRequest: {
        ...fundWithdrawOptions,
        advisorId: selectedAdvisor,
        partnerId: selectedPartner,
      },
    });
  };

  const executeFixedIncomeRedemption = (
    fixedIncomeWithdrawOptions: Omit<
      FixedIncomeResponsesExternalsPerformWithdrawRequest,
      'advisorId'
    >
  ) => {
    return Service.FixedIncome.V1.postWithdrawExecute({
      screenName,
      fixedIncomeResponsesExternalsPerformWithdrawRequest: {
        ...fixedIncomeWithdrawOptions,
        advisorId: selectedAdvisor,
        partnerId: selectedPartner,
      },
    });
  };

  const executeFixedIncomeAcceptQuotation = (
    fixedIncomeWithdrawOptions: Omit<
      FixedIncomeResponsesExternalsApprovalWithdrawRequest,
      'advisorId'
    >
  ) => {
    return Service.FixedIncome.V1.postWithdrawApprove({
      screenName,
      fixedIncomeResponsesExternalsApprovalWithdrawRequest: {
        ...fixedIncomeWithdrawOptions,
        advisorId: selectedAdvisor,
        partnerId: selectedPartner,
      },
    });
  };

  const executeDirectTreasuryRedemption = (
    directTreasuryWithdrawOptions: TreasuryWithdrawRequest
  ) => {
    return Service.Treasury.V1.postWithdrawExecute({
      screenName,
      treasuryWithdrawRequest: directTreasuryWithdrawOptions,
    }).then(({ data }) => ({
      financialValue: data.titles
        ? data.titles[0].financialValue
        : directTreasuryWithdrawOptions.financialValue,
      quantity: data.titles ? data.titles[0].quantity : directTreasuryWithdrawOptions.quantity,
    }));
  };

  return {
    executeFundsRedemption,
    executeFixedIncomeRedemption,
    executeFixedIncomeAcceptQuotation,
    executeDirectTreasuryRedemption,
  };
};
